export default "/images/info-theme.png?31974bf7d7010979f4c0da18a4be6a64";